export enum FilterType {
  CONTAINS = 'contains',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  EXACT_MATCH = 'exact_match',
  REGEX = 'regex',
}

export type Filter = {
  type: FilterType;
  value: string;
  case_sensitive: boolean;
};
